<template>
  <div>
    <div
      v-if="loading"
      class="col-12 text-center">
      <coozzy-spinner />
    </div>
    <div
      v-else
      class="row mb-2">
      <div class="col-12">
        <label>{{ $t('message.advertisement.contactPersonViewing') }}
          <coozzy-info-circle-icon
            v-if="showContactLockTooltip"
            v-b-tooltip.hover="$t('message.marketingObjects.viewingAppointments.contactLockedTooltip')" />
        </label>
        <div class="row px-3 mt-3">
          <coozzy-form-radio
            v-model="viewingAppointment.contactType"
            :default-model="viewingAppointment.contactType"
            :disabled="contactControlsDisabled"
            class="col"
            name="viewingAppointmentContactType"
            select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE">
            {{ $t('message.contact.types.EMPLOYEE') }}
          </coozzy-form-radio>
          <coozzy-form-radio
            v-if="tenantContacts.length > 0"
            v-model="viewingAppointment.contactType"
            :default-model="viewingAppointment.contactType"
            :disabled="contactControlsDisabled"
            class="col"
            name="viewingAppointmentContactType"
            select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT">
            {{ $t('message.generic.tenant') }}
          </coozzy-form-radio>
          <coozzy-form-radio
            v-if="contactIdsJanitor.length > 0"
            v-model="viewingAppointment.contactType"
            :default-model="viewingAppointment.contactType"
            :disabled="contactControlsDisabled"
            class="col"
            name="viewingAppointmentContactType"
            select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER">
            {{ $t('message.contact.types.janitor') }}
          </coozzy-form-radio>
          <coozzy-form-radio
            v-if="contactIdsServiceProvider.length > 0"
            v-model="viewingAppointment.contactType"
            :default-model="viewingAppointment.contactType"
            :disabled="contactControlsDisabled"
            class="col"
            name="viewingAppointmentContactType"
            select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER">
            {{ $t('message.contact.types.SERVICE_PROVIDER') }}
          </coozzy-form-radio>
          <coozzy-form-radio
            v-model="viewingAppointment.contactType"
            :default-model="viewingAppointment.contactType"
            :disabled="contactControlsDisabled"
            class="col"
            name="viewingAppointmentContactType"
            select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT">
            {{ $t('message.contact.types.anyContact') }}
          </coozzy-form-radio>
        </div>
      </div>
      <div
        v-if="viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE'"
        class="col-12 mt-3">
        <coozzy-form-select
          v-model="selectedViewingContactId"
          :disabled="contactControlsDisabled"
          class="select-entries float-right"
          name="numberEntries">
          <option value="">
            -
          </option>
          <option :value="contactIdAssigneeMarketing">
            {{ $t('message.advertisement.sameAsAssignee') }}
          </option>
          <option
            v-for="(employee, index) in availableEmployeeContacts"
            :key="index"
            :value="employee.id">
            {{ employee.firstName }} {{ employee.lastName }}
          </option>
        </coozzy-form-select>
      </div>
      <div
        v-if="viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT'"
        class="col-12 mt-3">
        <coozzy-form-select
          v-model="selectedViewingContactId"
          :disabled="contactControlsDisabled"
          class="select-entries float-right"
          name="numberEntries">
          <option value="">
            {{ $t('message.advertisement.contactPersonViewingPlaceholderTenant') }}
          </option>
          <option
            v-for="(tenant, index) in tenantContacts"
            :key="index"
            :value="tenant.id">
            {{ formatContactName(tenant) }}
          </option>
        </coozzy-form-select>
        <label v-if="hasContactPersons(selectedViewingContactId)">
          {{ $t('message.createOrder.contactPersonOfCompany') }}
        </label>
        <coozzy-form-select
          v-if="hasContactPersons(selectedViewingContactId)"
          v-model="selectedViewingContactPersonId"
          :disabled="contactControlsDisabled"
          class="select-entries float-right"
          name="employeeCompany">
          <option value="">
            -
          </option>
          <option
            v-for="(ten, index) in getContactPersons(selectedViewingContactId)"
            :key="index"
            :value="ten.id">
            {{ formatContactName(ten) }}
          </option>
        </coozzy-form-select>
      </div>
      <div
        v-if="viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER' || viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER'"
        class="col-12 mt-3">
        <coozzy-form-select
          v-model="selectedViewingContactId"
          :disabled="contactControlsDisabled"
          class="select-entries float-right"
          name="numberEntries">
          <option value="">
            {{
              viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER' ? $t('message.advertisement.contactPersonViewingPlaceholderJanitor') : $t('message.advertisement.contactPersonViewingPlaceholderServiceprovider')
            }}
          </option>
          <option
            v-for="(contactId, index) in (viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER' ? contactIdsJanitor : contactIdsServiceProvider)"
            :key="index"
            :value="contactId">
            {{ getContactName(contactId) }}
          </option>
        </coozzy-form-select>
        <label v-if="hasContactPersons(selectedViewingContactId)">
          {{ $t('message.createOrder.contactPersonOfCompany') }}
        </label>
        <coozzy-form-select
          v-if="hasContactPersons(selectedViewingContactId)"
          v-model="selectedViewingContactPersonId"
          :disabled="contactControlsDisabled"
          class="select-entries float-right"
          name="employeeCompany">
          <option value="">
            -
          </option>
          <option
            v-for="(jani, index) in getContactPersons(selectedViewingContactId)"
            :key="index"
            :value="jani.id">
            {{ formatContactName(jani) }}
          </option>
        </coozzy-form-select>
      </div>
      <div
        v-if="viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT'"
        class="col-12 mt-3">
        <div class="row">
          <div class="col mb-3">
            <coozzy-form-input
              v-model="viewingAppointmentRandom.firstName"
              :disabled="contactControlsDisabled"
              :name="$t('message.generic.firstName')" />
          </div>
          <div class="col mb-3">
            <coozzy-form-input
              v-model="viewingAppointmentRandom.lastName"
              :disabled="contactControlsDisabled"
              :name="$t('message.generic.lastName')" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <coozzy-form-input
              v-model="viewingAppointmentRandom.phone"
              :disabled="contactControlsDisabled"
              :name="$t('message.generic.phoneNumber')" />
          </div>
          <div class="col">
            <coozzy-form-input
              v-model="viewingAppointmentRandom.email"
              :disabled="contactControlsDisabled"
              :name="$t('message.generic.email')" />
          </div>
        </div>
      </div>
      <template v-if="showAdvertFields">
        <div class="col-12 mt-2">
          <coozzy-form-checkbox
            v-model="viewingAppointment.publishContact"
            :initial="viewingAppointment.publishContact"
            :disabled="readOnly"
            class="col-4"
            name="publishContact">
            {{ $t('message.advertisement.publishContactData') }}
          </coozzy-form-checkbox>
        </div>
        <div class="col-12 mt-3">
          <coozzy-form-textarea
            v-if="object"
            ref="remark"
            v-model="viewingAppointment.remark"
            :initial="viewingAppointment.remark"
            :disabled="readOnly"
            :limit="200"
            :placeholder="$t('message.advertisement.viewingAppointmentTextPlaceholder')"
            :rows="5"
            name="remark">
            {{ $t('message.advertisement.viewingAppointmentText') }}
          </coozzy-form-textarea>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import Vue from 'vue'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect'
import { mapActions, mapGetters } from 'vuex'
import { user } from '@/mixins/user'
import ObjectApi from '@/misc/apis/ObjectApi'
import ContactApi from '@/misc/apis/ContactApi'
import CoozzyFormRadio from '@/framework/components/form/radio/CoozzyFormRadio'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox'
import CoozzyFormTextarea from '@/framework/components/form/textarea/CoozzyFormTextarea'

export default {
  name: 'ViewingAppointmentContactSection',
  components: {
    CoozzyFormTextarea,
    CoozzyFormCheckbox,
    CoozzyFormInput,
    CoozzyFormRadio,
    CoozzyFormSelect,
    CoozzySpinner
  },
  mixins: [user],
  props: {
    object: {
      type: Object,
      default: null
    },
    building: {
      type: Object,
      default: null
    },
    buildingReady: {
      type: Boolean,
      default: true
    },
    contactIdAssigneeMarketing: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showAdvertFields: {
      type: Boolean,
      default: true
    },
    lockContactSelection: {
      type: Boolean,
      default: false
    },
    showContactLockTooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employeeContacts: [],
      employeeContactsLoaded: false,
      tenantContactsLoaded: false,
      tenantContacts: [],
      objectContactsLoaded: false,
      objectContacts: [],
      selectedViewingContactId: '',
      selectedViewingContactPersonId: '',
      viewingAppointment: {
        contactType: 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE',
        publishContact: false,
        remark: ''
      },
      viewingAppointmentRandom: {
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      },
      initialized: false,
      objectInitialized: false,
      suppressEmit: false,
      finalizing: false
    }
  },
  computed: {
    loading() {
      return !this.object || !this.employeeContactsLoaded || !this.tenantContactsLoaded || !this.objectContactsLoaded
    },
    contactControlsDisabled() {
      return this.readOnly || this.lockContactSelection
    },
    isContactSelectionComplete() {
      if (this.viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT') {
        return !!(this.viewingAppointmentRandom.email || '').trim()
      }
      if (this.hasContactPersons(this.selectedViewingContactId)) {
        return !!this.selectedViewingContactPersonId
      }
      return !!this.selectedViewingContactId
    },
    availableEmployees() {
      return this.getEmployees().filter(e => !e.blocked && !e.deleted)
    },
    availableEmployeeContacts() {
      return this.availableEmployees
        .map(e => this.employeeContacts.find(c => c.email === e.email))
        .filter(e => !!e)
    },
    contactIdsJanitor() {
      if (this.building?.contacts && Array.isArray(this.building.contacts)) {
        const ids = this.building.contacts
          .filter(c => c.type === 'BUILDING_CONTACT_TYPE_JANITOR')
          .map(c => c.id)
        return [...new Set(ids)]
      }
      return []
    },
    contactIdsServiceProvider() {
      if (this.building?.contacts && Array.isArray(this.building.contacts)) {
        const ids = this.building.contacts
          .filter(c => c.type === 'BUILDING_CONTACT_TYPE_SERVICE_PROVIDER')
          .map(c => c.id)
        return [...new Set(ids)]
      }
      return []
    },
    viewingAppointmentRandomClone() {
      return Object.assign({}, this.viewingAppointmentRandom)
    },
    viewingAppointmentPayload() {
      return {
        contactType: this.viewingAppointment.contactType,
        publishContact: this.viewingAppointment.publishContact,
        remark: this.viewingAppointment.remark,
        firstName: this.viewingAppointmentRandom.firstName,
        lastName: this.viewingAppointmentRandom.lastName,
        email: this.viewingAppointmentRandom.email,
        phone: this.viewingAppointmentRandom.phone
      }
    },
    resolvedViewingContactId() {
      if (this.selectedViewingContactPersonId) {
        return this.selectedViewingContactPersonId
      }
      return this.selectedViewingContactId
    },
    contactsLoaded() {
      return this.tenantContactsLoaded && this.objectContactsLoaded && this.employeeContactsLoaded
    },
    waitingForBuilding() {
      return !this.building && !!this.object?.buildingId && !this.buildingReady
    }
  },
  watch: {
    object: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal) {
          return
        }
        if (!oldVal || oldVal.id !== newVal.id) {
          this.objectInitialized = false
          this.initialized = false
          this.finalizing = false
          this.tenantContactsLoaded = false
          this.objectContactsLoaded = false
          this.loadTenants()
          this.loadObjectContacts()
          this.applyObjectData(newVal)
        } else if (this.objectInitialized) {
          this.applyObjectData(newVal)
        }
      }
    },
    contactsLoaded: function (loaded) {
      if (loaded) {
        this.finalizeInitialization()
      }
    },
    building: {
      handler(newVal, oldVal) {
        const buildingJustArrived = !oldVal && !!newVal
        if (!this.objectInitialized && !buildingJustArrived) {
          return
        }
        const newKey = this.getBuildingContactsKey(newVal)
        const oldKey = this.getBuildingContactsKey(oldVal)
        if (!buildingJustArrived && newKey === oldKey) {
          return
        }
        if (!this.object) {
          return
        }
        this.reloadObjectContactsAfterBuildingChange()
      }
    },
    buildingReady: {
      handler(ready) {
        if (!ready || this.building || !this.object) {
          return
        }
        if (!this.objectContactsLoaded) {
          this.loadObjectContacts()
          return
        }
        this.finalizeInitialization()
      }
    },
    'viewingAppointment.contactType': function (newVal, oldVal) {
      if (oldVal && newVal !== oldVal && this.initialized && !this.suppressEmit) {
        this.selectedViewingContactId = ''
        this.selectedViewingContactPersonId = ''
      }
    },
    selectedViewingContactId: function (newVal, oldVal) {
      if (this.initialized && !this.suppressEmit) {
        const oldContactPersonId = this.selectedViewingContactPersonId
        if (this.isPersonOfContact(newVal, oldContactPersonId)) {
          return
        }
        this.$emit('contact-selection-changed', {
          contactId: newVal,
          oldContactId: oldVal,
          contactPersonId: '',
          oldContactPersonId
        })
        this.selectedViewingContactPersonId = ''
        this.$emit('viewing-contact-updated', newVal)
      }
    },
    selectedViewingContactPersonId: function (newVal, oldVal) {
      if (this.initialized && !this.suppressEmit) {
        if (this.selectedViewingContactId !== '') {
          this.$emit('contact-selection-changed', {
            contactId: this.selectedViewingContactId,
            oldContactId: this.selectedViewingContactId,
            contactPersonId: newVal,
            oldContactPersonId: oldVal
          })
        }
        if (newVal !== '') {
          this.$emit('viewing-contact-updated', newVal)
        }
      }
    },
    viewingAppointmentRandomClone: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (this.initialized && !this.suppressEmit) {
          this.$emit('viewing-random-changed', { newVal, oldVal })
          this.emitViewingAppointmentUpdated()
        }
      }
    },
    viewingAppointment: {
      deep: true,
      handler: function () {
        if (this.initialized && !this.suppressEmit) {
          this.emitViewingAppointmentUpdated()
        }
      }
    }
  },
  mounted() {
    this.loadEmployees()
    this.loadEmployeeContacts()
  },
  methods: {
    ...mapActions('employee', ['loadEmployees']),
    ...mapGetters('employee', ['getEmployees']),
    applyObjectData(newVal) {
      this.suppressEmit = true
      if (newVal?.viewingAppointment) {
        this.viewingAppointment = { ...newVal.viewingAppointment }
        this.viewingAppointmentRandom = {
          firstName: newVal.viewingAppointment.firstName || '',
          lastName: newVal.viewingAppointment.lastName || '',
          email: newVal.viewingAppointment.email || '',
          phone: newVal.viewingAppointment.phone || ''
        }
      }

      if (!this.objectInitialized) {
        if (this.viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT' ||
          this.viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE') {
          this.selectedViewingContactId = newVal.contacts?.contactIdViewingAppointment || ''
        }
        this.objectInitialized = true
        this.$nextTick(() => {
          // Keep suppressing until finalizeInitialization finishes. Releasing here
          // lets mount/hydration watchers emit once contactsResolved is true.
          this.finalizeInitialization()
        })
      } else {
        this.$nextTick(() => {
          this.suppressEmit = false
        })
      }
    },
    finalizeInitialization() {
      if (this.initialized || this.finalizing || !this.objectInitialized || !this.contactsLoaded) {
        return
      }
      if (this.waitingForBuilding) {
        return
      }
      this.finalizing = true
      this.suppressEmit = true
      this.resolveViewingContactFromObject()
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.initialized = true
          this.finalizing = false
          this.$nextTick(() => {
            this.suppressEmit = false
            // Emit after suppressEmit is released so mount/select echoes run while
            // the parent still has contactsResolved=false and will not persist them.
            this.$nextTick(() => {
              this.$emit('contacts-resolved')
            })
          })
        })
      })
    },
    getBuildingContactsKey(building) {
      if (!building?.contacts || !Array.isArray(building.contacts)) {
        return ''
      }
      return building.contacts
        .filter(c => c.type === 'BUILDING_CONTACT_TYPE_JANITOR' || c.type === 'BUILDING_CONTACT_TYPE_SERVICE_PROVIDER')
        .map(c => `${c.type}:${c.id}`)
        .sort()
        .join('|')
    },
    reloadObjectContactsAfterBuildingChange() {
      this.suppressEmit = true
      this.objectContactsLoaded = false
      const contactIds = this.contactIdsJanitor.concat(this.contactIdsServiceProvider)
      const finish = () => {
        this.objectContactsLoaded = true
        this.resolveViewingContactFromObject()
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (!this.initialized) {
              this.finalizeInitialization()
              return
            }
            this.suppressEmit = false
          })
        })
      }
      if (!this.object || contactIds.length === 0) {
        this.objectContacts = []
        finish()
        return
      }
      ContactApi.contactResolve(contactIds)
        .then(response => {
          this.objectContacts = this.filterResolvedContacts(response.persons, response.companies, contactIds)
          finish()
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          this.objectContacts = []
          finish()
        })
    },
    emitViewingAppointmentUpdated() {
      if (this.suppressEmit) {
        return
      }
      this.$emit('viewing-appointment-updated', this.viewingAppointmentPayload)
    },
    revertContactSelection({ contactType, contactId, contactPersonId, viewingAppointment, freeText }) {
      this.suppressEmit = true
      if (viewingAppointment) {
        this.viewingAppointment = {
          contactType: viewingAppointment.contactType || contactType || this.viewingAppointment.contactType,
          publishContact: viewingAppointment.publishContact || false,
          remark: viewingAppointment.remark || ''
        }
      } else if (contactType) {
        this.viewingAppointment.contactType = contactType
      }
      if (freeText) {
        this.viewingAppointmentRandom = {
          firstName: freeText.firstName || '',
          lastName: freeText.lastName || '',
          email: freeText.email || '',
          phone: freeText.phone || ''
        }
      }
      this.$nextTick(() => {
        this.selectedViewingContactId = contactId || ''
        this.selectedViewingContactPersonId = contactPersonId || ''
        this.$nextTick(() => {
          this.suppressEmit = false
        })
      })
    },
    loadEmployeeContacts() {
      ContactApi.listEmployees(this.accountId)
        .then(response => {
          this.employeeContacts = response.persons
          this.employeeContactsLoaded = true
          this.finalizeInitialization()
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          this.employeeContactsLoaded = true
          this.finalizeInitialization()
        })
    },
    loadTenants() {
      if (!this.object) {
        this.tenantContactsLoaded = true
        this.finalizeInitialization()
        return
      }
      ObjectApi.listCurrentByObjectIds([this.object.id])
        .then(response => {
          if (response.tenancies.length > 0 && !response.tenancies[0].vacancy) {
            const tenantContactIds = response.tenancies[0].tenant.contactIds
            ContactApi.contactResolve(tenantContactIds)
              .then(resolveResponse => {
                this.tenantContacts = this.filterResolvedContacts(resolveResponse.persons, resolveResponse.companies, tenantContactIds)
                this.tenantContactsLoaded = true
                this.finalizeInitialization()
              })
              .catch(e => {
                console.log(e)
                Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
                this.tenantContactsLoaded = true
                this.finalizeInitialization()
              })
          } else {
            this.tenantContactsLoaded = true
            this.finalizeInitialization()
          }
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.tenancy'), { type: 'error' })
          this.tenantContactsLoaded = true
          this.finalizeInitialization()
        })
    },
    loadObjectContacts() {
      if (!this.object) {
        this.objectContacts = []
        this.objectContactsLoaded = true
        this.finalizeInitialization()
        return
      }
      const contactIds = this.contactIdsJanitor.concat(this.contactIdsServiceProvider)
      if (contactIds.length === 0) {
        if (this.waitingForBuilding) {
          // Building is still loading. Keep objectContactsLoaded false so we do
          // not emit contacts-resolved with an empty caretaker/service-provider
          // selection. The building watcher reloads when it arrives; buildingReady
          // resumes this path if the parent load fails and building stays null.
          return
        }
        this.objectContacts = []
        this.objectContactsLoaded = true
        this.finalizeInitialization()
        return
      }
      ContactApi.contactResolve(contactIds)
        .then(response => {
          this.objectContacts = this.filterResolvedContacts(response.persons, response.companies, contactIds)
          this.objectContactsLoaded = true
          this.finalizeInitialization()
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.contacts'), { type: 'error' })
          this.objectContacts = []
          this.objectContactsLoaded = true
          this.finalizeInitialization()
        })
    },
    resolveViewingContactFromObject() {
      const contactIdViewingAppointment = this.object?.contacts?.contactIdViewingAppointment
      if (!contactIdViewingAppointment) {
        return
      }
      if (['VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT'].includes(this.viewingAppointment.contactType)) {
        this.applyResolvedSelection(this.tenantContacts, this.tenantContacts.map(e => e.id), contactIdViewingAppointment)
      }
      if (['VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER', 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER'].includes(this.viewingAppointment.contactType)) {
        const dropdownIds = this.viewingAppointment.contactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER'
          ? this.contactIdsJanitor
          : this.contactIdsServiceProvider
        this.applyResolvedSelection(this.objectContacts, dropdownIds, contactIdViewingAppointment)
      }
    },
    applyResolvedSelection(contacts, dropdownIds, contactIdViewingAppointment) {
      if (dropdownIds.includes(contactIdViewingAppointment)) {
        this.selectedViewingContactId = contactIdViewingAppointment
        this.selectedViewingContactPersonId = ''
        return
      }
      const parent = contacts.find(e => this.contactMatchesId(e, contactIdViewingAppointment))
      const parentId = parent?.id || parent?.objectID || ''
      if (parentId && dropdownIds.includes(parentId)) {
        this.selectedViewingContactId = parentId
        this.selectedViewingContactPersonId = contactIdViewingAppointment
        return
      }
      const dropdownParentId = dropdownIds.find(id => (this.getContactPersons(id) || []).some(p => p.id === contactIdViewingAppointment))
      this.selectedViewingContactId = dropdownParentId || ''
      this.selectedViewingContactPersonId = this.selectedViewingContactId
        ? contactIdViewingAppointment
        : ''
    },
    filterResolvedContacts(persons, companies, contactIds) {
      return (persons || []).concat(companies || []).filter(contact => this.contactMatchesAnyId(contact, contactIds))
    },
    contactMatchesAnyId(contact, contactIds) {
      if (!contact || !contactIds?.length) {
        return false
      }
      return contactIds.some(id => this.contactMatchesId(contact, id))
    },
    contactMatchesId(contact, contactId) {
      if (!contact || !contactId) {
        return false
      }
      if (contact.id === contactId || contact.objectID === contactId) {
        return true
      }
      return (contact.contactPersons || []).some(person => person.id === contactId)
    },
    allResolvedContacts() {
      return this.availableEmployeeContacts
        .concat(this.tenantContacts)
        .concat(this.objectContacts)
    },
    getContact(contactId) {
      if (!contactId) {
        return undefined
      }
      const contacts = this.allResolvedContacts()
      const direct = contacts.find(contact => contact.id === contactId || contact.objectID === contactId)
      if (direct) {
        return direct
      }
      for (const contact of contacts) {
        const person = (contact.contactPersons || []).find(p => p.id === contactId)
        if (person) {
          return person
        }
      }
      return undefined
    },
    formatContactName(contact) {
      if (!contact) {
        return ''
      }
      const name = (contact.name || '').trim()
      if (name) {
        return name
      }
      return [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim()
    },
    getContactName(contactId) {
      const contact = this.getContact(contactId)
      const ownName = this.formatContactName(contact)
      if (ownName) {
        return ownName
      }
      const parent = this.allResolvedContacts().find(c => (c.contactPersons || []).some(p => p.id === contactId))
      return this.formatContactName(parent)
    },
    getContactPersons(contactId) {
      const contact = this.getContact(contactId)
      if (contact && contact.contactPersons && Array.isArray(contact.contactPersons)) {
        return contact.contactPersons
      }
      return undefined
    },
    hasContactPersons(contactId) {
      if (!contactId) {
        return false
      }
      return (this.getContactPersons(contactId) || []).length > 0
    },
    isPersonOfContact(contactId, contactPersonId) {
      if (!contactId || !contactPersonId) {
        return false
      }
      return (this.getContactPersons(contactId) || []).some(person => person.id === contactPersonId)
    },
    getContactInfoString(mainContactId, contactPersonId, random) {
      if (!mainContactId) {
        return this.getRandomInfoString(random)
      }
      if (contactPersonId && this.hasContactPersons(mainContactId)) {
        const contactPerson = this.getContactPersons(mainContactId).find(e => e.id === contactPersonId)
        if (contactPerson) {
          const phoneNumber = this.getPhoneNumbers(contactPerson.phoneNumbers)
          return this.$t('message.advertisement.contactTitle') + '<br>' + this.formatContactName(contactPerson) + '<br>' + phoneNumber + contactPerson.email + '<br>'
        }
      } else {
        const contact = this.getContact(mainContactId)
        if (contact) {
          const phoneNumber = this.getPhoneNumbers(contact.phoneNumbers)
          return this.$t('message.advertisement.contactTitle') + '<br>' + this.formatContactName(contact) + '<br>' + phoneNumber + contact.email + (phoneNumber || contact.email ? '<br>' : '')
        }
      }
      return ''
    },
    getRandomInfoString(random) {
      if (random.firstName !== '' || random.lastName !== '' || random.phone !== '' || random.email !== '') {
        return this.$t('message.advertisement.contactTitle') + '<br>' + random.firstName + ' ' + random.lastName + '<br>' +
          random.phone + (random.phone ? '<br>' : '') + random.email + (random.email ? '<br>' : '')
      }
      return ''
    },
    getPhoneNumbers(phoneNumbers) {
      let stringNumber = ''
      if (phoneNumbers && phoneNumbers.length > 0) {
        const arrayWORK = phoneNumbers.filter(number => number.type === 'WORK')
        const arrayMOBIL = phoneNumbers.filter(number => number.type === 'MOBILE')
        const arrayHOME = phoneNumbers.filter(number => number.type === 'HOME')
        if (arrayMOBIL.length > 0) {
          stringNumber += arrayMOBIL[0].number + '<br>'
        }
        if (arrayHOME.length > 0) {
          stringNumber += arrayHOME[0].number + '<br>'
        }
        if (arrayWORK.length > 0) {
          stringNumber += arrayWORK[0].number + '<br>'
        }
      }
      return stringNumber || ''
    }
  }
}
</script>
